import { BaseModel, NDArray, VariableMetadata } from '../types/model';
import { VariableOptionGroup } from '../components/shared/VariableSelect';

function ones(value: NDArray): NDArray {
  return Array.isArray(value) ? value.map(v => ones(v as NDArray)) as NDArray : 1;
}

/** Flatten representation paths for chart data; economic names stay unchanged. */
export function modelView(model: BaseModel) {
  const sol: Record<string, NDArray> = {};
  const baseline_sol: Record<string, NDArray> = {};
  const names: Record<string, string> = {};
  const metadata: Record<string, VariableMetadata> = {};
  for (const [key, spec] of Object.entries(model.variables)) {
    names[key] = `$${spec.symbol}$ — ${spec.meaning}`;
    metadata[key] = spec;
    for (const form of ['counterfactual', 'hats', 'baseline'] as const) {
      const value = model.sol[form][key];
      if (value == null) continue;
      const path = `${form}.${key}`;
      sol[path] = value;
      const before = model.sol.baseline[key];
      if (form === 'hats') baseline_sol[path] = ones(value);
      else if (before != null) baseline_sol[path] = before;
      const symbol = form === 'hats' ? `\\widehat{${spec.symbol}}` : form === 'baseline' ? spec.symbol : `{${spec.symbol}}^{\\prime}`;
      names[path] = `$${symbol}$ — ${spec.meaning}${form === 'hats' ? ' ratio' : ''}`;
      metadata[path] = { ...spec, units: form === 'hats' ? 'Ratio to baseline' : spec.units, calibration_url: null };
    }
  }
  return { ...model, sol, baseline_sol, variable_display_names: names, input_metadata: metadata };
}

export function groupVariables(
  keys: string[], metadata: Record<string, VariableMetadata>, displayNames: Record<string, string>,
): VariableOptionGroup[] {
  const groups = new Map<string, VariableOptionGroup>();
  for (const key of keys) {
    const shape = metadata[key].shape;
    const label = shape.length ? `(${shape.join(', ')})` : 'Scalar';
    const id = label;
    if (!groups.has(id)) groups.set(id, { label, options: [] });
    groups.get(id)!.options.push({ value: key, label: displayNames[key] });
  }
  return [...groups.values()];
}
